// The search screen's URL (`/operacoes/busca?id=`), written and read as plain query text, never
// through the router's JSON search serializer: the id reaches Power exactly as the operator typed
// it, so a search is a link the operator can share or reopen.
const SEARCH_PATH = '/operacoes/busca';
const ID_KEY = 'id';

/** The search screen's URL for `id`, the id written as plain query text. */
export const searchHref = (id: string): string =>
  `${SEARCH_PATH}?${new URLSearchParams({ [ID_KEY]: id }).toString()}`;

/** The id a search URL's query (`?id=…`) names; empty when it names none. */
export const searchIdOf = (searchStr: string): string =>
  new URLSearchParams(searchStr).get(ID_KEY) ?? '';
